import ReactPlayer from "react-player/lazy";

const ProductGallery = ({ productInfo }) => {
  return (
    <section className="flex gap-4 mb-8 sm2:flex-col">
      {productInfo.video && productInfo.video.length ? (
        <ProductVideo {...productInfo.video[0]} />
      ) : (
        <MainColorImage src={productInfo.image} name={productInfo.name} />
      )}
      <div className="grid grid-rows-2 gap-4 flex-1 h-[544px] sm2:flex sm2:flex-row sm2:gap-4 sm2:h-auto">
        {productInfo &&
          productInfo.gallery &&
          productInfo.gallery.map((image, idx) => (
            <ProductImage src={image} key={idx} />
          ))}
      </div>
    </section>
  );
};

const ProductImage = ({ src }) => {
  return (
    <div className="w-full h-full sm2:w-[calc(50%-0.5rem)] sm2:aspect-square overflow-hidden rounded-2xl">
      <img className="w-full h-full object-cover" alt="" src={src} />
    </div>
  );
};

const ProductVideo = ({ type, url, filename }) => {
  return (
    <div className="flex flex-col gap-2 w-2/3 sm2:w-full h-[544px]">
      <div className="w-full h-[calc(100%-20px)] bg-color-black rounded-2xl overflow-hidden">
        <ReactPlayer
          url={url}
          width="100%"
          height="100%"
          muted
          playing
          loop
          controls
        />
      </div>
      <a
        href="https://www.instagram.com/hairathomeapp/"
        reffe
        target="_blank"
        className="font-graphie font-normal text-base leading-[1.2rem] text-color-grey-600 w-fit"
      >
        Zdroj: Instagram Hair@Home
      </a>
    </div>
  );
};

const MainColorImage = ({ src, name }) => {
  return (
    <div className="w-2/3 h-[544px] sm2:w-full sm2:h-[16.5rem] rounded-2xl overflow-hidden">
      <img className="w-full h-full object-cover" alt={name} src={src} />
    </div>
  );
};

export default ProductGallery;
